import { BudgetApiClient } from '../api/client';
import { useAsync } from './useAsync';
import type { FilterOptions } from '../types';

export interface UseFilterOptionsResult {
  options: FilterOptions | null;
  isLoading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useFilterOptions(
  apiClient: BudgetApiClient,
  einzelplan: string | null,
  budgetType: 'E' | 'A' = 'A',
): UseFilterOptionsResult {
  const { data, error, isLoading, refetch } = useAsync<FilterOptions>(
    () => apiClient.getFilterOptions(einzelplan || undefined, budgetType),
    [apiClient, einzelplan, budgetType],
  );

  return { options: data, isLoading, error, refetch };
}
